export const TRANSLATION_PREFIX = 'STATIC.PAGES.REFERENCE_TABLE';

// Initial number of rows rendered, and how many more are revealed per infinite-scroll tick.
export const INITIAL_ROW_LIMIT = 250;
export const ROW_LIMIT_INCREMENT = 10;

// Rows are edited in the browser; larger tables must be imported/exported instead of hand-saved.
export const MAX_ROWS_FOR_MANUAL_CHANGES = 1000;

export const SUCCESS_TOAST_AUTO_CLOSE = 5000;

export const VALUE_CURRENCY_FIELD = 'value_currency';

// The dictionary-backed columns, in the display order used by the legacy Angular page.
// `field` is the row/payload key, `dict` is the dictionary that validates the cell.
export const COLUMNS = [
    {
        field: 'app',
        label: `${TRANSLATION_PREFIX}.COLUMNS.APP`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.APP`,
        dict: 'app',
    },
    {
        field: 'source',
        label: `${TRANSLATION_PREFIX}.COLUMNS.SOURCE`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.SOURCE`,
        dict: 'source',
    },
    {
        field: 'sub_adnetwork',
        label: `${TRANSLATION_PREFIX}.COLUMNS.SUB_ADNETWORK`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.SUB_ADNETWORK`,
        dict: 'sub_adnetwork',
    },
    {
        field: 'os',
        label: `${TRANSLATION_PREFIX}.COLUMNS.OS`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.OS`,
        dict: 'os',
    },
    {
        field: 'device',
        label: `${TRANSLATION_PREFIX}.COLUMNS.DEVICE`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.DEVICE`,
        dict: 'device',
    },
    {
        field: 'country',
        label: `${TRANSLATION_PREFIX}.COLUMNS.COUNTRY`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.COUNTRY`,
        dict: 'country',
    },
    {
        field: 'adn_account_id',
        label: `${TRANSLATION_PREFIX}.COLUMNS.ACCOUNT_ID`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.ACCOUNT_ID`,
        dict: 'adn_account_id',
    },
    {
        field: 'adn_original_currency',
        label: `${TRANSLATION_PREFIX}.COLUMNS.COST_CURRENCY`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.CURRENCY`,
        dict: 'adn_original_currency',
    },
    {
        field: 'tracker_original_currency',
        label: `${TRANSLATION_PREFIX}.COLUMNS.REVENUE_CURRENCY`,
        placeholder: `${TRANSLATION_PREFIX}.COLUMNS.CURRENCY`,
        dict: 'tracker_original_currency',
    },
];

// Every dictionary-backed field, including the optional value-currency column.
export const DICT_FIELDS = [...COLUMNS.map(column => column.field), VALUE_CURRENCY_FIELD];

// The CSV column key for the date column (kept identical to the legacy export/import contract).
export const CSV_DATE_HEADER = 'Rule Start Date';
export const CSV_VALUE_HEADER = 'value';

// Per-table help content, keyed by the table title returned from the backend.
export const TABLE_FAQ_LINKS = {
    'CPI Configuration':
        'https://support.singular.net/hc/en-us/articles/53658179746587-Reference-Tables-FAQ-Partner-Fees-and-CPI-Configuration',
    'Partner Fees':
        'https://support.singular.net/hc/en-us/articles/53658179746587-Reference-Tables-FAQ-Partner-Fees-and-CPI-Configuration',
};

// Value-column tooltip, keyed by table slug (matches the legacy ng-template tooltip).
export const VALUE_TOOLTIP_BY_SLUG = {
    'partner-fees': `${TRANSLATION_PREFIX}.VALUE_TOOLTIP.PARTNER_FEES`,
    'cpi-configuration': `${TRANSLATION_PREFIX}.VALUE_TOOLTIP.CPI_CONFIGURATION`,
};
